import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { ROUTES } from "@/app/routes";
import { Button } from "@/components/ui/button";

export function NotFoundPage() {
  const { t } = useTranslation("common");

  return (
    <section className="flex flex-col items-start gap-3">
      <h1 className="text-xl font-semibold">{t("notFound.title")}</h1>
      <p className="text-muted-foreground text-sm">
        {t("notFound.description")}
      </p>
      <Button asChild variant="outline">
        <Link to={ROUTES.home}>{t("notFound.backToHome")}</Link>
      </Button>
    </section>
  );
}
